import $ from 'jquery';

export default function multiNav (target) {
	$.fn.menumaker = function() {
		var cssmenu = $(this);
		return this.each(function() {
			// $(this).find("#menu-button").on('click', function(){
			// 	$(this).toggleClass('menu-opened');
			// 	var mainmenu = $(this).next('ul');
			// 	if (mainmenu.hasClass('open')) {
			// 		mainmenu.hide().removeClass('open');
			// 	} else {
			// 		mainmenu.show().addClass('open');
			// 		if (settings.format === "dropdown") {
			// 		mainmenu.find('ul').show();
			// 		}
			// 	}
			// });

			// Group and grid wrappers are just containers inside an already-toggled
			// submenu, so only real accordion levels get a trigger.
			cssmenu.find('li ul').parent().not('.navigation-primary__group, .navigation-primary__grid').addClass('has-sub');
			cssmenu.find(".has-sub").prepend('<button type="button" class="navigation-primary__multinav-trigger" aria-label="Open navigation"><span aria-hidden="true">Open</span></button>');
			// Open state lives on the parent <li> (.has-sub--open); CSS shows its child
			// <ul> elements, so any number of them open and close together.
			cssmenu.find('.navigation-primary__multinav-trigger').on('click', function() {
				var $trigger = $(this);
				var isOpen = $trigger.parent().toggleClass('has-sub--open').hasClass('has-sub--open');
				$trigger
					.toggleClass('navigation-primary__multinav-trigger--active', isOpen)
					.attr('aria-expanded', isOpen)
					.find('span').text(isOpen ? 'Close' : 'Open');
			});
		});
	};

	$(target).menumaker({});
}